<template>
  <div class="home__slider">
    <div class="slider__container">
      <swiper ref="homeSlider" :options="bannerItems.length > 1 ? slideOptions : {}">
        <swiper-slide v-for="(slide, index) in bannerItems" :key="index">
          <div class="slider__slide">
            <a :href="`/${slide.button_url}`" v-if="slide.button_url">
              <picture>
                <source :srcset="`/${slide.image_path_mobile.replace(/^\/+/, '')}`" media="(max-width: 768px)"/>
                <img :src="`/${slide.image_path_desktop.replace(/^\/+/, '')}`" :alt="slide.content_title" :loading="index === 0 ? 'eager' : 'lazy'" :fetchpriority="index === 0 ? 'high' : 'low'"/>
              </picture>
            </a>
            <picture v-else>
              <source :srcset="`/${slide.image_path_mobile.replace(/^\/+/, '')}`" media="(max-width: 768px)"/>
              <img :src="`/${slide.image_path_desktop.replace(/^\/+/, '')}`" :alt="slide.content_title" :loading="index === 0 ? 'eager' : 'lazy'" :fetchpriority="index === 0 ? 'high' : 'low'"/>
            </picture>
          </div>
        </swiper-slide>
        <div class="swiper-pagination-bullets" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper';
  import 'swiper/css/swiper.css';

  @Component({
    name: 'home-slider',
    components: {
      Swiper,
      SwiperSlide
    },
    directives: {
      swiper: directive
    }
  })

  export default class extends Vue {
    @Prop() readonly bannerItems: Array<object>;

    private slideOptions: object = {
      loop: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination-bullets',
        clickable: true
      }
    };
  }
</script>
